import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useFirstModule } from "../provider/invoiceProvider";
import trusted from "../assets/trusted.svg";
import info from "../assets/info.svg";
import lock from "../assets/lock1.svg";
import vampaylogo from "../assets/vampaylogo.svg";
import abLogo from "../assets/vampay.svg";
import CustomInput from "../components/customInput";
import NewCustomInput from "../components/newCustomInput";
export default function FourthAmountPayable() {
  const { invoiceData } = useFirstModule();

  return (
    <div className="my-6">
      <Card
        sx={{
          minWidth: 275,
          minHeight: 400,
          borderRadius: 4,
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#2F5EE1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <CardContent className="mt-8 ">
          <div className="py-4 ">
            {/* <div className="pb-2 text-[24px] heading text-center opacity-75 text-black">
              <p style={{ fontWeight: "normal" }} className="text-[24px]">
                Amount payable
              </p>
            </div> */}
            <div className="flex flex-col items-center justify-center w-full gap-2">
              <div className="flex items-center justify-center w-16 h-16 rounded-lg">
                <img
                  src={invoiceData?.merchant_logo || abLogo}
                  alt="logo"
                  height={100}
                  width={100}
                  className=""
                />
              </div>
              <div className=" text-[18px] font-semibold text-[#ffffff]">
                <p>{invoiceData?.vendor_name}</p>
              </div>
              <div className="flex bg-[#436EE3] items-center justify-center text-[12px] font-semibold text-[#ffffff] p-1">
                <img
                  src={trusted}
                  alt="logo"
                  height={20}
                  width={20}
                  className=""
                />{" "}
                <p>Vampay Trusted Business </p>{" "}
                <img
                  src={info}
                  alt="logo"
                  height={20}
                  width={20}
                  className=""
                />
              </div>
              <div className=""></div>
              <div className="w-full heading text-wrap ">
                <NewCustomInput
                  inputType="number"
                  label={invoiceData?.payable_amount ? "₹" : ""}
                  value={invoiceData?.payable_amount}
                  placeholder="Enter Amount"
                  customStyle={{
                    height: 40,
                    fontSize: 30,
                    backgroundColor: "#7593EA",
                  }}
                  disabled={true}
                  inputClass="bg-[#7593EA] w-full no-spinner text-[16px] text-[#ffffff] font-medium"
                  labelStyle="text-[#ffffff] "
                />
              </div>
            </div>
          </div>
        </CardContent>
        <div className="flex items-center gap-1 py-2">
          <img src={lock} alt="logo" height={30} width={30} className="" />{" "}
          <p className="text-[#fff]">Secured by</p>
          <img
            src={vampaylogo}
            alt="logo"
            height={60}
            width={60}
            className=""
          />{" "}
        </div>
      </Card>
    </div>
  );
}
